export default __webpack_public_path__ + "static/media/background.6675a8b2.jpg";